import { render } from "./PptCoursewardCard.vue?vue&type=template&id=36271ef5&scoped=true"
import script from "./PptCoursewardCard.vue?vue&type=script&lang=ts"
export * from "./PptCoursewardCard.vue?vue&type=script&lang=ts"

import "./PptCoursewardCard.vue?vue&type=style&index=0&id=36271ef5&scoped=true&lang=css"
import "./PptCoursewardCard.vue?vue&type=style&index=1&id=36271ef5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-36271ef5"

export default script